import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import Search from "../../../../components/Search";
import withRouter from "../../../../withRouter";
import LeaveManagementPresenter from "../LeaveManagementPresenter";
import LeaveRequestForm from "./leave-management-form/LeaveRequestForm";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import DateRangePicker from "../../../../components/common/DateRangePicker";
import InputFactory from "../../../../components/InputFactory";
import ViewLeaveRequestForm from "./leave-management-form/ViewLeaveRequestForm";

class LeaveRequestPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LeaveManagementPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      progress: false,
    };
    this.state = {
      objects: [],
      object: {},
      type: [],
      status: [],
      isLeaveReqOpen: false,
      filteredstatus: "",
      leaveType: "",
      leavType: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }
  async componentDidMount() {
    this.presenter.componentDidMount();
    const type = await findObjectUseCase().execute("leave_type");
    const status = await findObjectUseCase().execute("leave_request");
    this.setState({ type, status });
  }

  getCurrent() {
    return this.getCurrentUser();
  }

  getCollectionName() {
    return "leave_request";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleAddTraining() {
    this.setState({ isLeaveReqOpen: true, object: {} });
  }

  async handleViewData(object) {
    this.setState({ object, isViewLeaveReqOpen: true });
  }

  // async onChangeForm(field, value) {
  //   this.setState({ [field]: value });
  //   if (field === "leavType") {
  //     this.onChangeFilter("String", value, "selectedType");
  //   } else if (field === "filteredstatus") {
  //     this.onChangeFilter("String", value, "stats");
  //   }
  // }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;

    if (!schema) return <Progress />;

    const excludeFieldsFather = [
      "selectedType",
      "halfDay",
      "startdate",
      "enddate",
      "createdAt",
      "duration",
      "stats",
    ];
    const applyField = Object.keys(schema.fields).filter(
      (key) => !excludeFieldsFather.includes(key),
    );
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex">
                  {Object.keys(schema.filters || {}).map((field) => {
                    if (field === "employee") {
                      return null;
                    }
                    let { type, ...options } = schema.filters[field];
                    console.log("OPTIONS: ", options);
                    return (
                      <div className="col-md-3 mt-1" key={field}>
                        <InputFactory
                          key={field}
                          type={type}
                          field={field}
                          where={{}}
                          onChange={this.onChangeFilter.bind(this, type)}
                          {...options}
                        />
                      </div>
                    );
                  })}

                  <div className="col-md-3 mt-1">
                    <DateRangePicker
                      fields={["startdate", "enddate", "employee.id"]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>

                  <div className="col-md-3 mt-1">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}s</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.handleAddTraining.bind(this)}>
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectData={this.handleViewData.bind(this)}
                objectDataDis={(data) => this.presenter.handleCancelBtn(data)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                  {
                    label: (
                      <i className="bi bi-x-lg" style={{ color: "red" }}>
                        {" "}
                        Cancel
                      </i>
                    ),
                    actionType: "objectDis",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, applyField)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isLeaveReqOpen && (
          <LeaveRequestForm
            closeTrainingForm={() => this.setState({ isLeaveReqOpen: false })}
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
          />
        )}
        {this.state.isViewLeaveReqOpen && (
          <LeaveRequestForm
            closeTrainingForm={() =>
              this.setState({ isViewLeaveReqOpen: false })
            }
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
          />
        )}
      </>
    );
  }
}

export default withRouter(LeaveRequestPage);
